import {Component, OnInit, ViewChild} from '@angular/core';
import {Menu} from 'primeng/menu';
import {ConfirmationService, ConfirmEventType, MenuItem, MessageService} from 'primeng/api';
import {Router} from '@angular/router';
import {Paginator} from 'primeng/paginator';
import {AdminControlService} from '../@shared/services/admin-control.service';
import {ImUserService} from '../@shared/services/im-user.service';
import {DatePipe} from '@angular/common';
import * as FileSaver from 'file-saver';

@Component({
    selector: 'app-user-management',
    templateUrl: './user-management.component.html',
    styleUrls: ['./user-management.component.scss']
})
export class UserManagementComponent implements OnInit {
    @ViewChild('pagination') pagination: Paginator;
    @ViewChild('menu') menuItem: Menu;
    actionMenu: MenuItem[];
    allUsers: any;
    pagedUser: any;
    selectedUser: any;
    isLoading: boolean;
    identifier = ' ';
    isFileDownloading: boolean;

    constructor(private router: Router,
                private adminControlService: AdminControlService, private imUserService: ImUserService, private messageService: MessageService,
                private confirmationService: ConfirmationService) {
    }

    ngOnInit(): void {
        this.getAllUsers(0, 10, this.identifier);
    }

    navigateToUpdateCurrentUser(action?: any) {
        if (action === 'edit') {
            this.router.navigate(['update-user'], {queryParams: {userId: this.selectedUser?.userId}});
        } else if (action === 'resetPassword') {
            this.router.navigate(['update-user'], {
                queryParams: {
                    userId: this.selectedUser?.userId,
                    updatePassword: 'updatePassword'
                }
            });
        } else if (action === 'new') {
            this.router.navigate(['update-user']);
        }
    }

    handleToggle(event: Event, user) {
        this.selectedUser = user;
        this.actionMenu = user?.actionMenu;
        this.menuItem.toggle(event);
    }

    getAllUsers(page: number = 0, size: number = 10, identifier?: string) {
        this.isLoading = true;
        this.adminControlService.getUser(page, size, this.identifier)
            .subscribe(
                (x) => {
                    x?.content.map((res) => {
                        const user: any = res as any;
                        const menuItems: MenuItem[] = this.createActionMenuForThisBooking(user);
                        user.actionMenu = menuItems;
                    });
                    this.allUsers = x?.content;
                    this.pagedUser = x;
                    console.log(this.pagedUser, 'this.pagedUser');
                    this.isLoading = false;
                }, error => {
                    this.messageService.add({
                        summary: 'Unable to get user !',
                        severity: 'error',
                        detail: error?.message ? error?.message : error,
                        key: 'user-management',
                        sticky: true
                    });
                    this.isLoading = false;
                }
            );
    }


    createActionMenuForThisBooking(user: any): MenuItem[] {
        const menuItems: MenuItem[] = [];
        const block: MenuItem = {
            label: 'Block',
            visible: true,
            command: () => {
                this.updateUserStatus(this.selectedUser?.userId, false);
            }
        };

        const unBlock: MenuItem = {
            label: 'UnBlock',
            visible: true,
            command: () => {
                this.updateUserStatus(this.selectedUser?.userId, true);
            }
        };

        const resetPassword: MenuItem = {
            label: 'Reset Password',
            visible: true,
            command: () => {
                this.navigateToUpdateCurrentUser('resetPassword');
            }
        };

        const editUser: MenuItem = {
            label: 'Edit User',
            visible: true,
            command: () => {
                this.navigateToUpdateCurrentUser('edit');
            }
        };


        if (user?.enabled) {
            menuItems.push(editUser);
            menuItems.push(resetPassword);
            menuItems.push(block);
        } else {
            menuItems.push(editUser);
            menuItems.push(resetPassword);
            menuItems.push(unBlock);
        }
        return menuItems;
    }

    updateUserStatus(userId, enabled) {
        const userStatusBody = {
            enabled,
            userId
        };
        // @ts-ignore
        this.adminControlService.updateUserStatus(userStatusBody)
            .subscribe((res) => {
                    this.getAllUsers(0, 10, this.identifier);
                    this.messageService.add({
                        summary: 'Status Updated...',
                        severity: 'success',
                        detail: 'Status Updated...',
                        key: 'success-message',
                        sticky: true
                    });
                },
                error => {
                    this.messageService.add({
                        summary: 'Unable to Block User  !',
                        severity: 'error',
                        detail: error?.message ? error?.message : error,
                        key: 'error-message',
                        sticky: true
                    });
                });
    }

    paginateFilteredUsers(event: any) {
        console.log(event, ' event ---');
        // @ts-ignore
        // const page = this.pagination._page(event?.page);
        this.getAllUsers(event?.page, event?.rows);
    }

    onSearch(event: any) {
        this.identifier = event.target.value;
        this.getAllUsers(0, 10, this.identifier);
    }

    exportExcel(dataContent: any) {
        const exportedBookings = this.exportedColumnsForFileDownload(dataContent);
        import('xlsx').then(xlsx => {
            const worksheet = xlsx.utils.json_to_sheet(exportedBookings);
            const workbook = {Sheets: {data: worksheet}, SheetNames: ['data']};
            const excelBuffer: any = xlsx.write(workbook, {bookType: 'xlsx', type: 'array'});
            this.saveAsExcelFile(excelBuffer, 'users-listing');
        });
    }

    saveAsExcelFile(buffer: any, fileName: string): void {
        const EXCEL_TYPE = 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8';
        const EXCEL_EXTENSION = '.xlsx';
        const data: Blob = new Blob([buffer], {
            type: EXCEL_TYPE
        });
        FileSaver.saveAs(data, fileName + '_export_' + new Date().getTime() + EXCEL_EXTENSION);
    }

    exportedColumnsForFileDownload(dataContent: any) {
        const datePipe = new DatePipe('en-US');
        const exportedUsers = dataContent?.map((user) => {
            const exportUser = {
                'Email Id': user?.emailId ? user?.emailId : '-',
                'First Name': user?.firstName ? user?.firstName : '-',
                'Last Name': user?.lastName ? user?.lastName : '-',
            };
            return exportUser;
        });
        return exportedUsers;
    }

    downloadFiles() {
        this.confirmationService.confirm({
            message: 'Select the option to download file.',
            header: 'Download Options',
            icon: 'pi pi-download',
            accept: () => {
                // Download the current page only.
                this.exportExcel(this.pagedUser?.content);

            },
            reject: (type) => {
                switch (type) {
                    case ConfirmEventType.REJECT:
                        // Download All Pages
                        this.isFileDownloading = true;
                        this.adminControlService?.getUser(0, 10000, this.identifier)
                            .subscribe((x) => {
                                this.isFileDownloading = false;
                                this.exportExcel(x?.content);

                            });
                        break;
                    case ConfirmEventType.CANCEL:
                        // Closed dialog box without any options to download.
                        break;
                }
            }
        });
    }

}
